/**
 * @generated SignedSource<<8906e13e06d2ba9f28e4a2fe17f55c35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContentBlockDeleteMutation$variables = {
  id: string;
};
export type ContentBlockDeleteMutation$data = {
  readonly contentBlockDelete: {
    readonly success: boolean | null;
  } | null;
};
export type ContentBlockDeleteMutation = {
  response: ContentBlockDeleteMutation$data;
  variables: ContentBlockDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ContentBlockDelete",
    "kind": "LinkedField",
    "name": "contentBlockDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentBlockDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentBlockDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a6df492d4032933e4d916b366e74957e",
    "id": null,
    "metadata": {},
    "name": "ContentBlockDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ContentBlockDeleteMutation(\n  $id: ID!\n) {\n  contentBlockDelete(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "47dd2b69a5cfe7677ad95cb3e51e481d";

export default node;
